import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function CompanyPage() {
  return (
    <div className="company-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="hero-bg-image" style={{ backgroundImage: 'url(/images/hero-company.png)' }}></div>
        <div className="page-header-overlay"></div>
        <Container>
          <h1 className="page-title">Company</h1>
        </Container>
      </section>

      {/* Mission / Vision / Values */}
      <section className="section-mvv">
        <Container>
          <div className="mvv-block">
            <h2 className="mvv-label">Mission</h2>
            <h3 className="mvv-statement">事業の成長に、同じ熱量でコミットする。</h3>
            <p className="mvv-description">
              クライアントの事業そのものに深く入り込み、共通の目標を掲げ、
              成果に連動する報酬体系のもとで、同じ方向を向いて事業を成長させていく。
              それが私たちの考えるグロースパートナーのあり方です。
            </p>
          </div>

          <div className="mvv-block">
            <h2 className="mvv-label">Vision</h2>
            <h3 className="mvv-statement">仕組みの力で、関わるすべての人の可能性を拡張する。</h3>
            <p className="mvv-description">
              テクノロジーと設計力で、クライアントの事業を、チームメンバーの働き方を、
              そして日本のビジネスパーソンの未来を変えていきます。
              時間労働ではなく価値創出で報われる世界を、私たちから実現していきます。
            </p>
          </div>

          <div className="mvv-block">
            <h2 className="mvv-label">Values</h2>
            <div className="values-grid">
              <div className="value-card">
                <h4 className="value-title">Aligned Incentive</h4>
                <p className="value-subtitle">インセンティブを一致させる</p>
                <p className="value-description">
                  誰かが損をする構造からは、持続的な成長は生まれません。
                  だから私たちは、クライアントともチームメンバーとも、
                  全員が同じ方向を向ける仕組みを設計します。
                </p>
              </div>
              <div className="value-card">
                <h4 className="value-title">Design over Execution</h4>
                <p className="value-subtitle">実行の前に、設計する</p>
                <p className="value-description">
                  広告を回す前に、まず事業の構造を設計します。
                  目の前のCPAではなく、入口から出口まで、その先までを見通した全体設計があってこそ、
                  本当の成果につながると考えています。
                </p>
              </div>
              <div className="value-card">
                <h4 className="value-title">Build to Last</h4>
                <p className="value-subtitle">資産として積み上げる</p>
                <p className="value-description">
                  消耗する広告費ではなく、積み上がる仕組みを作ります。
                  今日の仕事が明日の仕事を楽にしていく。その積み重ねが、
                  クライアントにとっても私たちにとっても、揺るがない競争優位になっていきます。
                </p>
              </div>
              <div className="value-card">
                <h4 className="value-title">Technology as Leverage</h4>
                <p className="value-subtitle">テクノロジーをてこにする</p>
                <p className="value-description">
                  RPA、AI、自動化。人がやるべきことと仕組みに任せるべきことを見極め、
                  少ない労力で大きな成果を生み出します。
                  テクノロジーは人を置き換えるものではなく、人の可能性を広げるものだと考えています。
                </p>
              </div>
            </div>
          </div>
        </Container>
      </section>

      {/* Work Style */}
      <section className="section-workstyle">
        <Container>
          <h2 className="section-label">Work Style</h2>
          <p className="section-description-text">私たちの働き方</p>
          <div className="workstyle-items">
            <div className="workstyle-card">
              <h4>オールリモート</h4>
              <p>
                PerfTechはオールリモート・非同期型の組織です。
                海外のGitLabや国内のキャスターをモデルに、
                場所や時間に縛られない働き方を追求しています。
                全国から優秀な人材が参画できる環境を整えています。
              </p>
            </div>
            <div className="workstyle-card">
              <h4>時間労働から価値創出へ</h4>
              <p>
                私たちが目指すのは、時間ではなく価値で報われる組織です。
                日を重ねるごとに仕組み化が進み、仕事は楽になっていく。
                それでも収入は上がり続ける。
                RPAや自動化技術を自ら活用し、この理想を実現しています。
              </p>
            </div>
            <div className="workstyle-card">
              <h4>世界で戦える人材の育成</h4>
              <p>
                日本人は優秀で勤勉です。もっと世界に評価されるべきだと考えています。
                組織の一コマではなく、プロジェクトの責任を背負い、
                自ら考え行動できる人材を育てていくことが、
                私たちの大切な使命のひとつです。
              </p>
            </div>
          </div>
        </Container>
      </section>

      {/* Message */}
      <section className="section-message">
        <Container>
          <Row className="align-items-center">
            <Col lg={5} className="mb-4 mb-lg-0">
              <div className="message-image-wrapper">
                <img src="/images/company-message.jpg" alt="代表メッセージ" className="message-image" />
              </div>
            </Col>
            <Col lg={7}>
              <div style={{ paddingLeft: 'clamp(0px, 3vw, 40px)' }}>
                <h2 className="section-label">Message</h2>
                <div className="message-content">
                  <p>
                    クライアントの事業が成長すること。
                    それが私たちにとっての成果であり、報酬の源泉です。
                  </p>
                  <p>
                    広告の世界には、構造的な矛盾があります。
                    予算を増やすことが目的化し、クライアントと本当に同じ方向を向けているのか
                    疑問に思う場面が少なくありません。
                  </p>
                  <p>
                    私たちは、クライアントと共通の目標を持ち、成果に連動する形で事業に関わっていくことを選びました。
                    入口の集客だけでなく、事業全体のグロースに責任を持つ。
                    そのために必要な設計力とテクノロジーを磨き続けています。
                  </p>
                  <p>
                    また、私たち自身の組織のあり方にも同じ哲学を持っています。
                    チームメンバーが時間ではなく価値で報われ、日を重ねるごとに仕事が楽になり、
                    収入が上がっていく。そんな働き方を実現できる仕組みを作っていきたいと考えています。
                  </p>
                  <p>
                    世界で戦える人材を、この場所から育てていく。
                    それも私たちの大切な使命です。
                  </p>
                  <div className="message-signature">
                    <span className="signature-company">PerfTech株式会社　代表取締役</span>
                    <img src="/images/signature-iwasaki.png" alt="岩崎 厚樹" className="signature-handwritten" />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Partnership */}
      <section className="section-partnership">
        <Container>
          <h2 className="section-label">Partnership</h2>
          <p className="section-description-text">コンプライアンス体制</p>
          <Row className="justify-content-center">
            <Col lg={8}>
              <div className="partnership-content">
                <p>
                  健康食品や美容、医療関連の領域では、薬機法・景表法・医療広告ガイドラインなど、
                  厳格な法規制への対応が求められます。
                </p>
                <p>
                  PerfTechでは、薬事・法規制に精通した専門パートナーと事業提携を行い、
                  攻めの施策と守りのコンプライアンスを両立させる体制を構築しています。
                  戦略の立案段階から法規制のチェックを組み込むことで、
                  リスクを未然に防ぎながら、最大限の成果を追求します。
                </p>
                <div className="partnership-features">
                  <Row>
                    <Col sm={6} className="mb-3">
                      <div className="partnership-feature">
                        <h5>薬機法対応</h5>
                        <p>健康食品・化粧品等の広告表現に関する法的チェック体制</p>
                      </div>
                    </Col>
                    <Col sm={6} className="mb-3">
                      <div className="partnership-feature">
                        <h5>景表法対応</h5>
                        <p>不当表示の防止、エビデンスに基づく適正な表現の管理</p>
                      </div>
                    </Col>
                    <Col sm={6} className="mb-3">
                      <div className="partnership-feature">
                        <h5>医療広告ガイドライン</h5>
                        <p>医療機関の広告に関する規制への準拠</p>
                      </div>
                    </Col>
                    <Col sm={6} className="mb-3">
                      <div className="partnership-feature">
                        <h5>機能性表示食品対応</h5>
                        <p>届出範囲を踏まえた適正な訴求設計</p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Company Overview */}
      <section className="section-overview">
        <Container>
          <h2 className="section-label">Company Overview</h2>
          <div className="overview-table">
            <div className="overview-row">
              <div className="overview-label">会社名</div>
              <div className="overview-value">PerfTech株式会社（パーフテック）</div>
            </div>
            <div className="overview-row">
              <div className="overview-label">設立</div>
              <div className="overview-value">2023年10月</div>
            </div>
            <div className="overview-row">
              <div className="overview-label">資本金</div>
              <div className="overview-value">1,000万円</div>
            </div>
            <div className="overview-row">
              <div className="overview-label">所在地</div>
              <div className="overview-value">
                〒103-0022<br />
                東京都中央区日本橋室町1-11-12 日本橋水野ビル7F
              </div>
            </div>
            <div className="overview-row">
              <div className="overview-label">事業内容</div>
              <div className="overview-value">
                グロースパートナー事業<br />
                （集客設計・オウンドメディア構築・RPA構築・AI導入支援・SNS運用オートメーション）
              </div>
            </div>
          </div>
        </Container>
      </section>

      {/* CTA */}
      <section className="section-cta">
        <Container>
          <h2>共に成長できるパートナーを、<br className="d-md-none" />探しています。</h2>
          <p className="cta-sub">
            私たちは、すべてのご相談をお受けしているわけではありません。
            商品やサービスに真剣に向き合い、共に成長していける関係を大切にしています。
            まずは、お互いにとって最善かどうかを一緒に考えるところから始めませんか。
          </p>
          <Link to="/contact" className="btn-primary-custom">
            ご相談はこちら
          </Link>
        </Container>
      </section>
    </div>
  );
}

export default CompanyPage;
